interface ControllerBase<Req, Res> {
    request: Req
    response: Res
}

export interface SchemasReceivePoint {
    /** 포인트 받기 API */
    '/:paymentId': ControllerBase<
        {
            /** 결제번호 */
            paymentId: string
        },
        {
            resultCode: string
            resultMessage?: string
            /** 해당 결제건으로 적립받은 금액 */
            acmAmount: number
        }
    >
    /** 적립에 대한 요약 정보 조회 (강화문구 조회) */
    '/rewardSummary': ControllerBase<
        {
            /** 결제번호 */
            paymentId: string
        },
        {
            code: Constant<typeof ReceivePointStatusCode>
            message: string
            body?: {
                /** 결제번호 */
                payId: string
                /** 강화문구 타입 */
                supplementaryInfoType: Constant<typeof SupplementaryType>
                /** 강화문구에 필요한 금액 (없으면 0) */
                supplementaryInfoAmount: number
            }
        }
    >
    /** 추가 적립 가능한 주문건 조회 API */
    '/additionalReward': ControllerBase<
        {
            /** 결제번호 */
            paymentId: string
        },
        {
            payment: Maybe<AdditionalReward>
            order: Maybe<AdditionalReward>
        }
    >
}

/** 적립 이어서 받기 정보 */
interface AdditionalReward {
    /** 주문번호 */
    orderNo: string
    /** 상품주문번호 */
    productOrderNo: string
    /** 상품명 */
    productName: string
    /** 상품이미지 URL */
    productImageUrl: string
    /** 적립금 */
    rewardAmount: number
}

/** 적립 방식 */
export const RewardMethod = {
    /** 포인트 받기를 통한 적립 */
    RECEIVE_POINT: 'RECEIVE_POINT',
    /** 구매확정 후 적립 */
    AFTER_CONFIRMATION: 'AFTER_CONFIRMATION',
} as const

/**
 * 포인트 받기 상태 코드
 * @deprecated 결제형 BE 아닌 혜택 BE에서 관리
 */
export const ReceivePointStatusCode = {
    /** 성공 */
    Success: 'Success',
    /** 유효하지 않은 결제번호 */
    InvalidPaymentId: 'InvalidPaymentId',
    /** 이미 적립된 결제건 */
    AlreadyConfirmedPoint: 'AlreadyConfirmedPoint',
    /** 적립할 금액이 없는 결제건 */
    InvalidPointConfirm: 'InvalidPointConfirm',
    /** 포인트 받기 정책 적용전 or 적립 예정일이 7일 이후인 결제건 */
    NotActivatedPointConfirm: 'NotActivatedPointConfirm',
} as const

/** 강화문구 타입 */
export const SupplementaryType = {
    /** 페이머니 홍보 */
    PAY_MONEY: 'PAY_MONEY',
    /** 총 적립금액 노출 */
    CUMULATION: 'CUMULATION',
    /** 해당사항 없음 */
    NONE: 'NONE',
} as const

/**
 * 포인트 받기 결과 코드
 * @see https://oss.fin.navercorp.com/Product-Planning/Online-Payment_Plan/issues/752#issuecomment-2226309
 * @see http://alpha.benefit-point-api.pay.navercorp.com/swagger-ui/index.html#/NSP-ACM-TRADE/manualConfirmUsingPOST
 */
export const ReceivePointResultCode = {
    /** 성공 */
    SUCCESS: '1000',
    /** 이미 적립된 거래 */
    ALREADY_RECEIVED: '1001',
    /** 유효하지 않은 요청 (적립 거래 없음(적립기준일 없음) = 다른 계정으로 접근 등) */
    INVALID_REQUEST: 'P002',
    /** 포인트 받기 가능한 기간이 아님 */
    PERIOD_NOT_ACTIVE: '9999',
} as const
